import { createObservable } from 'src/utils/observable';
import type { NativeToWebMessage, WebToNativeMessage } from './types';

const APP_IDENTIFIER = 'copera-collaborate-app';
const MESSAGE_VERSION = 'v1';

const serializeMessage = <T>(message: T): string => {
  return JSON.stringify(message);
};

const deserializeMessage = <T>(messageString: string): T => {
  try {
    return JSON.parse(messageString) as T;
  } catch (error) {
    throw new Error(`Falha ao deserializar mensagem: ${error}`);
  }
};

const handleIncomingMessage = (event: MessageEvent): void => {
  try {
    const data = String(event.data);
    if (!data.startsWith('copera-collaborate-app:')) return;

    const [prefix, version, ...rest] = data.split(':');
    const messageData = rest.join(':');
    if (prefix !== APP_IDENTIFIER || version !== MESSAGE_VERSION) return;

    const message = deserializeMessage<NativeToWebMessage>(messageData);
    collaborateNativeToWeb.next(message);
  } catch (error) {
    console.error('Erro ao processar mensagem recebida:', error);
  }
};

export const sendCollaborateBridgeMessage = (
  message: WebToNativeMessage,
): void => {
  if (window.ReactNativeWebView) {
    const messageString = serializeMessage(message);
    const prefixedMessage = `${APP_IDENTIFIER}:${MESSAGE_VERSION}:${messageString}`;
    window.ReactNativeWebView.postMessage(prefixedMessage);
  } else {
    console.warn('ReactNativeWebView não está disponível para enviar mensagem');
  }
};

export const collaborateNativeToWeb = createObservable<NativeToWebMessage>();
export const collaborateWebToNative = createObservable<WebToNativeMessage>();

window.addEventListener('message', handleIncomingMessage);
